
































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import RemuneracaoGeracaoRepasseRightNavBar from '@/components/RemuneracaoMedica/NavBar/RemuneracaoGeracaoRepasseRightNavBar.vue'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import { RequestMessage, IRequestMessage } from '@/types/_'
import moment from 'moment'
import _ from 'lodash'
import EventBus from '@/plugins/EventBus'
import { maskDateTime, displayColorByStatusGeracaoRepasse } from '@/utils/common'
import HistoricoSituacaoStore from '@/components/HistoricoSituacao/Store/HistoricoSituacaoStore'
import RegrasDeCalculoStore from '@/components/RemuneracaoMedica/RegrasDeCalculo/Store/RegrasDeCalculoStore'
import { useProducaoNaoCalculada } from '@/composables'

@Component({
  components: {
    RemuneracaoGeracaoRepasseRightNavBar,
  },
})
export default class ViewFinanceiroGeracaoDeRepasse extends Vue {
  getRequestMessage: IRequestMessage = new RequestMessage()
  loadVisualizarGeracaoRepasse: string = ''
  loadDescartados: string = ''
  loadGerarRepasses: boolean = false
  loadFecharGeracaoRepasse: boolean = false
  loadHistorico: string = ''
  modalGerarRepasse: boolean = false
  modalVisualizarGeracaoRepasse: boolean = false
  modalFecharGeracao: boolean = false
  sel: any[] = []

  $refs: {
    dtPicker: any,
  }

  textFieldProp: any = {
    appendIcon: 'event',
    errorMessages: '',
  }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get getRegrasDeCalculoStore() {
    return getModule(RegrasDeCalculoStore, this.$store)
  }

  get fontesPagadoras() {
    return this.getFinanceiroStore.fontePagadoras
  }

  get showModalFecharGeracao() {
    return this.modalFecharGeracao
  }

  set showModalFecharGeracao(value: boolean) {
    this.modalFecharGeracao = value
  }

  get getHistoricoSituacaoStore() {
    return getModule(HistoricoSituacaoStore, this.$store)
  }

  get signalRResponse() {
    return this.getFinanceiroStore.message
  }

  get getPagina() {
    return this.getFinanceiroStore.paginaGeracao
  }

  set getPagina(value: number) {
    this.getFinanceiroStore.setPaginaGeracao(value)
  }

  get getTotal() {
    return this.getFinanceiroStore.totalGeracaoDeRepasse || 0
  }

  get repasseLength() {
    return Math.ceil(this.getTotal / this.getFinanceiroStore.qtdPorPagina)
  }

  get loadingVisualizarGeracaoRepasse() {
    return this.loadVisualizarGeracaoRepasse
  }

  set loadingVisualizarGeracaoRepasse(value: string) {
    this.loadVisualizarGeracaoRepasse = value
  }

  get loadingDescartados() {
    return this.loadDescartados
  }

  set loadingDescartados(value: string) {
    this.loadDescartados = value
  }

  get loadingGerarRepasses() {
    return this.loadGerarRepasses
  }

  set loadingGerarRepasses(value: boolean) {
    this.loadGerarRepasses = value
  }

  get loadingFecharGeracaoRepasse() {
    return this.loadFecharGeracaoRepasse
  }

  set loadingFecharGeracaoRepasse(value: boolean) {
    this.loadFecharGeracaoRepasse = value
  }

  get loadingHistorico() {
    return this.loadHistorico
  }

  set loadingHistorico(value: string) {
    this.loadHistorico = value
  }

  get visibleResults() {
    if (this.$vuetify.breakpoint.smAndDown) return 4
    if (this.$vuetify.breakpoint.md) return 7
    if (this.$vuetify.breakpoint.lg) return 9
    return 15
  }

  get headers() {
    return this.getFinanceiroStore.backofficeFinanceiroGeracaoRepasseHeaders
  }

  get geracaoDeRepassesItems() {
    return this.getFinanceiroStore.geracaoDeRepassesItems
  }

  get statusGeracaoRepasse() {
    return this.getFinanceiroStore.statusGeracaoRepasse
  }

  set statusGeracaoRepasse(value: any) {
    this.getFinanceiroStore.setStatusGeracaoRepasse(value.key ? value.key : value)
  }

  get fontePagadoraFilter() {
    return this.getFinanceiroStore.fontePagadoraFilter
  }

  set fontePagadoraFilter(value: any) {
    this.getFinanceiroStore.setFontePagadoraFilter(value)
  }

  get status() {
    return this.getFinanceiroStore.statusGeracaoRepasseFiltro
  }

  get drawer() {
    return this.getFinanceiroStore.geracaoDrawer
  }

  set drawer(value: boolean) {
    this.getFinanceiroStore.setGeracaoDrawer(value)
  }

  get selected() { return this.sel }
  set selected(value: any) { this.sel = value }

  get calculoAtivo() { return this.getFinanceiroStore.calculoAtivo }

  async selectStatus(item: any) {
    this.statusGeracaoRepasse = item

    await this.$nextTick(() => {
      this.filter()
    })
  }

  async selectPrestador(item: any) {
    this.fontePagadoraFilter = item
    await this.$nextTick(() => {
      this.filter()
    })
  }

  async filter() {
    this.getFinanceiroStore.clearPagePagination()
    this.getFinanceiroStore.setPaginaGeracao(1)
    EventBus.$emit('setLoadingRequest', { status: this.getRequestMessage.status, text: this.getRequestMessage.init.text })
    await this.getFinanceiroStore.getGeracaoRepasseAll()
    EventBus.$emit('clearLoadingRequest')
  }

  async clearAdvancedFilters() {
    this.getFinanceiroStore.clearFilterGeracaoRepasse()
    this.getFinanceiroStore.setPaginaGeracao(1)
    await this.getFinanceiroStore.getGeracaoRepasseAll()
  }

  formatDateTimeUtil(date) {
    return maskDateTime(date)
  }

  formatDateUtil(date: string | null | undefined) {
    if (['', null, undefined].includes(date)) return ''
    return moment(date).format('MM/YYYY')
  }

  async openModalGerarRepasse() {
    this.loadingGerarRepasses = true
    this.getFinanceiroStore.setModal({ name: 'gerarRepasse', value: true })
    this.loadingGerarRepasses = false
  }

  openModalEmitirRelatorio() {
    this.getFinanceiroStore.setModal({ name: 'emitirRelatorioEmLote', value: true })
  }

  async showAdvancedFilters() {
    this.drawer = !this.drawer
  }

  async visualizarGeracaoRepasse(item: any) {
    this.loadingVisualizarGeracaoRepasse = item.id
    this.getFinanceiroStore.podeLiberarRepasse(item.status.key)
    this.getFinanceiroStore.podeDescartarRepasse(item.acoes.podeDescartar)
    this.getFinanceiroStore.setStatusGeracaoDeRepasse(item.status.key)
    this.getFinanceiroStore.setIdForLoadValidacaoEGeracaoRepasse(item.id)
    this.getFinanceiroStore.setActiveTab(0)
    this.getFinanceiroStore.setTipoGeracaoRepasse(item.tipo.key)
    await this.getFinanceiroStore.getCargasVisualizarItems()
    await this.getFinanceiroStore.getStatusList()
    await this.getFinanceiroStore.getGerarRepassePrestadores(item.id)
    this.semearFiltrosDaListagem()
    await this.getFinanceiroStore.getGeracaoDeRepassesItemsVisualizar(item.id)
    await this.getFinanceiroStore.getProcedimentosDescarteRecriacao()
    this.getFinanceiroStore.setModal({ name: 'validacaoEGeracaoRepasse', value: true })
    this.modalVisualizarGeracaoRepasse = true
    this.loadingVisualizarGeracaoRepasse = ''
  }

  // FXSR-2689 — o filtro da listagem entra pré-preenchido (e editável) na lista de repasses da
  // geração, e daí é herdado pela lista de itens. Os autocompletes de baixo renderizam a partir de
  // profissionaisExecutantes/gerarRepassePrestadores: só o id deixaria o campo vazio, por isso o
  // objeto { userId, nome } também é semeado nessas listas. Roda a cada abertura, então geração
  // seguinte não herda o filtro da anterior.
  semearFiltrosDaListagem() {
    const store = this.getFinanceiroStore

    const profissional = store.geracaoProfissionaisOptions
      .find((item: any) => item.userId === store.geracaoProfissionalFilter)

    store.setSelectedProfissionalExecutante(store.geracaoProfissionalFilter)
    store.setProfissionaisExecutantes(profissional ? [profissional] : [])
    store.setProfissionais('')

    store.setSelectedPrestador(store.geracaoPrestadorFilter)

    const prestadorNaLista = store.gerarRepassePrestadores
      .some((item: any) => item.userId === store.geracaoPrestadorFilter)
    const prestador = store.geracaoPrestadoresOptions
      .find((item: any) => item.userId === store.geracaoPrestadorFilter)

    if (prestador && !prestadorNaLista) {
      store.setGerarRepassePrestadores([...store.gerarRepassePrestadores, prestador])
    }
  }

  async visualizarDescartados(item: any) {
    this.loadingDescartados = item.id
    this.getFinanceiroStore.setIdForLoadProcedimentosDescartados(item.id)
    await this.getFinanceiroStore.getProcedimentosDescartados()
    this.getFinanceiroStore.setModal({ name: 'procedimentosDescartados', value: true })
    this.modalVisualizarGeracaoRepasse = true
    this.loadingDescartados = ''
  }

  openModalFecharGeracao(id: string) {
    this.getFinanceiroStore.setIdForCloseGeracao(id)
    this.showModalFecharGeracao = true
  }

  async confirmarFecharGeracao() {
    this.loadingFecharGeracaoRepasse = true
    await this.getFinanceiroStore.fecharGeracaoRepasse()
    await this.getResults(this.getPagina)
    this.showModalFecharGeracao = false
    this.loadingFecharGeracaoRepasse = false
  }

  @Watch('selected')
  async onSelectedChange() {
    this.getFinanceiroStore.setEmitirRelatorioEmLote(this.selected)
  }

  @Watch('signalRResponse')
  async onSignalRResponseChange() {
    if (this.signalRResponse) {
      await this.getFinanceiroStore.getGeracaoRepasseAll()
    }
  }

  async getResults(pagina: number) {
    EventBus.$emit('setLoadingRequest', { status: this.getRequestMessage.status, text: this.getRequestMessage.init.text })
    this.getPagina = pagina
    await this.getFinanceiroStore.getGeracaoRepasseAll()
    EventBus.$emit('clearLoadingRequest')
  }

  displayColor(item: { status: { key: string, display: string } }) {
    return displayColorByStatusGeracaoRepasse(item.status.display)
  }

  // FXSR-2984/2989 — badge de produção nova não calculada: dispara lazy, sobre os ids da página
  // atual, toda vez que a grade troca de conteúdo (paginação, filtro ou atualização via SignalR).
  // Falha silenciosa (sem showToastError) — é informação auxiliar, a listagem não pode quebrar por
  // causa dela.
  @Watch('geracaoDeRepassesItems')
  onGeracaoDeRepassesItemsChange(items: any[]) {
    const ids = (items || []).map(item => item.id)
    if (ids.length) useProducaoNaoCalculada.loadByGeracaoIds(ids)
  }

  producaoNaoCalculada(geracaoRepasseId: string) {
    const item = useProducaoNaoCalculada.getByGeracaoId(geracaoRepasseId)
    return item && item.temProducaoNaoCalculada ? item : null
  }

  producaoNaoCalculadaTotalLabel(geracaoRepasseId: string) {
    const item = this.producaoNaoCalculada(geracaoRepasseId)
    if (!item) return ''
    const total = item.quantidadeIncluivel + item.quantidadeBloqueada
    return item.atingiuLimite ? `${total}+` : `${total}`
  }

  producaoNaoCalculadaTooltip(geracaoRepasseId: string) {
    const item = this.producaoNaoCalculada(geracaoRepasseId)
    if (!item) return ''
    let texto = `${this.producaoNaoCalculadaTotalLabel(geracaoRepasseId)} produções novas ainda não calculadas.`
    if (item.quantidadeBloqueada > 0) {
      const verbo = item.quantidadeBloqueada === 1 ? 'está' : 'estão'
      texto += ` ${item.quantidadeBloqueada} ${verbo} em repasse já liberado e exige${item.quantidadeBloqueada === 1 ? '' : 'm'} desfazer a liberação.`
    }
    return `${texto} Abra a geração para incluí-las.`
  }

  async init() {
    EventBus.$emit('setLoadingRequest', { status: this.getRequestMessage.status, text: this.getRequestMessage.init.text })
    // await this.getFinanceiroStore.closeConnection()
    await this.getFinanceiroStore.getCondicaoPagamentoAll()
    await this.getFinanceiroStore.getFontePagadoraAll()
    await this.getFinanceiroStore.getStatusGeracaoRepasse()
    await this.getFinanceiroStore.getGrupoHospital()
    await this.getFinanceiroStore.getTipoEnum()
    await this.getRegrasDeCalculoStore.getPrestadoresRepasse({ limite: 20 })
    // await this.getFinanceiroStore.openConnection(this.getFinanceiroStore.grupoHospitalId)

    await this.getFinanceiroStore.getGeracaoRepasseAll()

    EventBus.$emit('clearLoadingRequest')
  }

  get dadosRecebidos() {
    return this.getFinanceiroStore.message
  }

  set dadosRecebidos(value: any) {
    this.getFinanceiroStore.addMessage(value)
  }

  onAtualizarDadosGeracaoRepasse(data) {
    if (this.getFinanceiroStore.gruposHospitaisIds.includes(data.estabelicimentoId)) {
      EventBus.$emit('setSnackbar', { show: true, text: 'O cálculo de produção foi gerado com sucesso!', icon: 'done', color: '#2E7D32', timeout: 5500 })
      this.dadosRecebidos = data
    }
  }

  async mounted() {
    await this.init()

    EventBus.$on('atualizarDadosGeracaoRepasse', this.onAtualizarDadosGeracaoRepasse)
  }

  beforeMount() {
    const status = ['Concluido', 'Aguardando', 'Liberado', 'Erro', 'Integrando', 'Integrado']

    this.statusGeracaoRepasse = status
  }

  // O FinanceiroStore é singleton da sessão: sem isto o filtro e a geração aberta sobrevivem
  // à saída da tela e reaparecem na volta (FXSR-2715).
  beforeDestroy() {
    EventBus.$off('atualizarDadosGeracaoRepasse', this.onAtualizarDadosGeracaoRepasse)

    this.getFinanceiroStore.setModal({ name: 'validacaoEGeracaoRepasse', value: false })
    this.getFinanceiroStore.clearFilterGeracaoRepasse()
  }
}
